import React from 'react';
import './LoaderFlashcardExplain.css';

const LoaderFlashcardExplain = () => {
  return (
    <div className="Loader__flashcard__Explain__loader">
      <div className="Loader__flashcard__Explain__loader__line Loader__flashcard__Explain__loader__l1"></div>
      <div className="Loader__flashcard__Explain__loader__line Loader__flashcard__Explain__loader__l2"></div>
      <div className="Loader__flashcard__Explain__loader__line Loader__flashcard__Explain__loader__l3"></div>
      <div className="Loader__flashcard__Explain__loader__line Loader__flashcard__Explain__loader__l4"></div>
      <div className="Loader__flashcard__Explain__loader__line Loader__flashcard__Explain__loader__l5"></div>
    </div>
  );
}

export default LoaderFlashcardExplain;
